<div class="term-card card-header-green"
     fxLayout="column"
     ngClass.lt-md="term-card-sm"
     ngClass.lt-sm="term-card-xs">
  <div class="term-card-header"
       fxLayout="row"
       fxLayoutAlign="start center"
       fxLayoutGap="16px">
    <mat-icon class="header-icon">assessment</mat-icon>
    <div class="mat-headline-5">Term Loan{{ calculator.express ? ' *' : '' }}</div>
  </div>
  <div fxLayout="row"
       fxLayoutAlign="center center"
       fxLayoutGap="16px">
    <section *ngIf="showSlider" class="slider-section">
      <fieldset>
        <legend>
          Loan amount
        </legend>
        <input class="draw-amount card-header-green"
               currencyMask
               type="text"
               (blur)="onAmountBlur()"
               [(ngModel)]="amount" />
      </fieldset>
      <mat-slider class="slider"
                  color="white"
                  [min]="calculator.minAmount"
                  [max]="calculator.maxAmount"
                  [step]="1000"
                  discrete
                  [displayWith]="onAmountDisplay">
        <input matSliderThumb
               [(ngModel)]="amount"
               (change)="onChange()">
      </mat-slider>
    </section>
    <div fxLayout="column"
         fxLayoutGap="16px"
         fxLayout.lt-md="column"
         fxLayoutAlign="center center">
      <ifc-bar-chart [data]="barChartData"
                     [options]="barChartOptions">
      </ifc-bar-chart>
      <span class="sub-title">Outstanding balance over time</span>
    </div>
    <div class="express-footer"
         *ngIf="calculator.express">
      * Express Checkout is not subject to additional credit underwriting.
    </div>
  </div>
</div>

<mat-card appearance="outlined"
          class="sample-details"
          ngClass.lt-md="sample-details-sm"
          ngClass.lt-sm="sample-details-xs">
  <mat-card-content fxLayout="row"
                    fxLayoutAlign="space-between"
                    fxLayout.lt-md="column"
                    fxLayoutGap="16px"
                    class="card-content">
    <section fxFlex="46%">
      <h2 class="heading">Details</h2>
      <ifc-horizontal-list [items]="detailsListItems"></ifc-horizontal-list>
    </section>
    <section fxFlex="46%"
             class="features">
      <h2 class="heading">Other features</h2>
      <div class="content"
           fxLayout="column">
        <p>
          <span class="title">Disbursed amount:</span> The disbursed amount that we will transfer to your designated
          bank account will be
          reduced by any amount owed to Idea Financial from a prior loan or used to pay off an amount owed to a third
          party.
        </p>
        <p>
          <span class="title">Payoff discount:</span> Unpaid finance charges will be reduced by 50% should you pay off this
          loan in full before
          your
          last payment is due. The remaining unpaid finance charges are due upon full pay off.
        </p>
        <p>
          <span class="title">Renewals:</span> After you have paid your loan by 50% you may be eligible for renewal
          subject to a credit
          review.
        </p>
        <p *ngIf="calculator.hasDisclosures">
          <a (click)="showDisclosures(calculator.application.id, calculator.application.uuid, calculator.applicationOffer.id)"
             class="disclosure-link">Click here to read disclosures required by law.</a>
        </p>
      </div>
    </section>
  </mat-card-content>
</mat-card>

<ifc-offer-calculator-closing-requirements [checkoutRequirements]="calculator.applicationOfferBundle.checkoutRequirements"
                                           [isOfferBundleSelected]="calculator.applicationOfferBundle.status === offerBundleStatusEnum.Accepted"
                                           (documentsClick)="onDocumentsClick(calculator.application?.id, calculator.applicationOfferBundle?.id)">
</ifc-offer-calculator-closing-requirements>

<ifc-link-your-bank [bankLinkStatus]="calculator.application?.bankLinkStatus"
                    (linkBank)="onLinkBank(calculator.application?.entityId)">
</ifc-link-your-bank>

<ifc-offer-calculator-payment-schedule [offer]="calculator.applicationOffer"
                                       [sampleDraw]="calculator.amount">
</ifc-offer-calculator-payment-schedule>
